exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".check-button {\n  width: 7rem;\n  height: 7rem;\n  background: #fff;\n  border-radius: 0.6rem;\n  position: relative;\n  border: 1px solid #0d3a52;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.check-button>span {\n  display: none;\n  font-size: 4rem;\n}\n\n.check-button.check-button--active {\n  background: #839AA7;\n}\n\n.check-button.check-button--active>span {\n  display: block;\n}\n\n", ""]);

// exports
